import axios from 'axios'
import types from '../store/types'
import store from '../store'
import { v4 as uuidv4 } from 'uuid'

axios.defaults.withCredentials = false

// const baseURL = process.env.NODE_ENV === 'development' ? 'https://checkup.selvy.ai/v3-dev' : 'https://checkup.selvy.ai/v3'
// const baseURL = process.env.NODE_ENV === 'development' ? 'https://checkup.selvy.ai/v3-dev' : 'https://checkup.selvy.ai/v3'
// const baseURL = process.env.NODE_ENV === 'development' ? 'https://checkup.selvy.ai/v3-dev' : 'https://checkup.selvy.ai/v3-dev'
 const baseURL = process.env.NODE_ENV === 'development' ? 'https://checkup.selvy.ai/v3' : 'https://checkup.selvy.ai/v3'

function makeAxios (authToken) {
    return axios.create({
        baseURL: baseURL,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-AUTH-TOKEN': authToken,
        }
    })
}

const apiCaller = {
    call: async function(method, path, params, query, authToken = null) {
        if (method === undefined || path === undefined) {
            throw Error('The parameters method and path must be required.')
        }

        method = method.toUpperCase()

        const key = uuidv4()
        let url = `${path}`

        if (query) {
            url = `${url}?${Object.keys(query).map(key => `${key}=${query[key]}`).join('&')}`
        }

        store.dispatch(types.api.actions.push, { key })

        let result = {
            data: { },
            error: null,
            message: null
        }
        let res = null

        try {
            if (method === 'GET') {
                res = await makeAxios(authToken).get(url)
            } else if (method === 'POST') {
                res = await makeAxios(authToken).post(url, params)
            }

            console.log('[API]', method, url, params, JSON.stringify(params), res.data)
            const errorCode = Number(res.data.code)
            if (errorCode === 200) {
                result.data = res.data.result
            } else {
                console.error(res.data)
                store.dispatch(types.api.actions.errorCode, { errorCode })
            }
        } catch(e) {
            console.error(e)
            store.dispatch(types.snackBar.actions.show, { text: 'Network Error', color: 'red lighten-1' })
            throw result
        } finally {
            store.dispatch(types.api.actions.pop, { key })
        }

        return res
    }
}

export default {
    sign: {
        agreeToken: async function () {
            return await apiCaller.call('GET', '/agree/token')
        },
        idCheck: async function ({ userId }) {
            return await apiCaller.call('GET', `/signup/idcheck/${userId}`)
        },
        tokenCheck: async function ({ agreeToken }) {
            return await apiCaller.call('GET', '/signup/tokencheck', null, { s_token: agreeToken })
        },
        up: async function ({ email, name, password, agreeToken, userId }) {
            return await apiCaller.call('POST', '/signup/do', { email, name, password, userId, token: agreeToken })
        },
        in: async function ({ password, userId }) {
            return await apiCaller.call('POST', '/signin', { password, userId })
        },
        me: async function ({ authToken }) {
            return await apiCaller.call('GET', '/me', null, null, authToken)
        },
        changeEmail: async function ({ authToken, birthday, email, gender, name, password, userId }) {
            return await apiCaller.call('POST', '/me/email', {
                birthday, email, gender, name, password, userId
            }, null, authToken)
        },
        changePassword: async function ({ authToken, currentPassword, newPassword }) {
            return await apiCaller.call('POST', '/me/password', {
                currentPassword, newPassword
            }, null, authToken)
        },
        signupWithCode: async function (code) {
            return await apiCaller.call('GET', `/signup/withcode/${code}`)
        },
        authBySid: async function (sid) {
            return await apiCaller.call('GET', `/external/auth?libraryType=L&sid=${sid}`)
        },
        getFCInfo: async function ({ authToken, fcCode }) {
            return await apiCaller.call('POST', '/fclink/fccodeCheck', { fcCode }, null, authToken)
        },
        async updateInfo({authToken, name, mobile}) {
            return await apiCaller.call('POST', '/me/update', {name, mobile}, null, authToken)
        },
        async getSiteInfo({ authToken, siteId}) {
            return await apiCaller.call('POST', `/me/site/${siteId}`, {siteId}, null, authToken)
        }
    },
    report: {
        list: async function ({ authToken }) {
            return await apiCaller.call('GET', '/reports', null, null, authToken)
        },
        detail: async function ({ authToken, checkupNo }) {
            return await apiCaller.call('GET', `/reports/${checkupNo}`, null, null, authToken)
        },
        deleteItem: async function ({ authToken, checkupNo }) {
            return await apiCaller.call('GET', `/reports/delete/${checkupNo}`, null, null, authToken)
        }
    },
    checkUp: {
        add: async function ({ authToken, birthday, blds, bmi, bpHigh, bpLow, checkupDate, creatinine, dfabPtnCd, drnkHabit, drnkQty, fmly, gammaGtp, gender, hchk, hdlChole, heightCm, heightFeet, heightInch, heightUnit, hmg, ldlChole, mov20WekFreq, mov30WekFreq, name, oligProteCd, sgotAst, sgptAlt, smkQty, smkStatType, totChole, triglyceride, waistCm, waistInch, waistUnit, weightKg, weightLb, weightUnit, wlk30WekFreq, smkTerm }) {
            return await apiCaller.call('POST', '/checkup/add',
                { birthday, blds, bmi, bpHigh, bpLow, checkupDate, creatinine, dfabPtnCd, drnkHabit, drnkQty, fmly, gammaGtp, gender, hchk, hdlChole, heightCm, heightFeet, heightInch, heightUnit, hmg, ldlChole, mov20WekFreq, mov30WekFreq, name, oligProteCd, sgotAst, sgptAlt, smkQty, smkStatType, totChole, triglyceride, waistCm, waistInch, waistUnit, weightKg, weightLb, weightUnit, wlk30WekFreq, smkTerm },
                null,
                      authToken
            )
        },
        add2: async function ( { authToken, survey } ) {
            console.log('add2', authToken, survey)
            return await apiCaller.call('POST', '/checkup/add', survey, null, authToken)
        },
        modify: async function ({ authToken, checkupNo, birthday, blds, bmi, bpHigh, bpLow, checkupDate, creatinine, dfabPtnCd, drnkHabit, drnkQty, fmly, gammaGtp, gender, hchk, hdlChole, heightCm, heightFeet, heightInch, heightUnit, hmg, ldlChole, mov20WekFreq, mov30WekFreq, name, oligProteCd, sgotAst, sgptAlt, smkQty, smkStatType, totChole, triglyceride, waistCm, waistInch, waistUnit, weightKg, weightLb, weightUnit, wlk30WekFreq, smkTerm }) {
            return await apiCaller.call('POST', `/checkup/${checkupNo}`,
                { birthday, blds, bmi, bpHigh, bpLow, checkupDate, creatinine, dfabPtnCd, drnkHabit, drnkQty, fmly, gammaGtp, gender, hchk, hdlChole, heightCm, heightFeet, heightInch, heightUnit, hmg, ldlChole, mov20WekFreq, mov30WekFreq, name, oligProteCd, sgotAst, sgptAlt, smkQty, smkStatType, totChole, triglyceride, waistCm, waistInch, waistUnit, weightKg, weightLb, weightUnit, wlk30WekFreq, smkTerm },
                null,
                      authToken
            )
        },
        modify2: async function ( { authToken, checkupNo, survey }) {
            console.log('modify', authToken, checkupNo, survey)
            return await apiCaller.call('POST', `/checkup/${checkupNo}`, survey, null, authToken)
        },
        get: async function ({ authToken, checkupNo }) {
            return await apiCaller.call('GET', `/checkup/${checkupNo}`, null, null, authToken)
        }
    }
}

